export default defineNuxtRouteMiddleware(async (to, from) => {
    const { signOut } = useAuthentication()
    const userStore = useUserStore()

    if (userStore.role === 'member' && to.path !== '/authenticated/admin/**') {
        await signOut()
        userStore.resetStore()

        return abortNavigation({
            statusCode: 401,
            statusMessage: 'Unauthorized',
            message: 'Security Violation! You are not authorized to access this area.',
            fatal: true
        })
    }
})
